import LaravelLogo from './images/laravel.png'

const DefaultImage = [
    LaravelLogo
];
export default DefaultImage